"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MessageSquare, Twitch, Smartphone, Download } from "lucide-react";
const socials = [{
  name: "Facebook",
  icon: Twitch,
  desc: "Community updates and project news.",
  href: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-wrap justify-center gap-6">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-4 w-20 animate-pulse rounded-md bg-muted" />)}
      </ul>;
  }
  return <ul className="flex flex-wrap justify-center gap-6 font-default text-xs font-semibold tracking-widest uppercase">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="transition-colors hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function GamingSocialFooter() {
  return <section data-section-id="255501" id="footer" className="dark bg-background text-foreground overflow-hidden pt-16 pb-8">
      <div className="page-container">
        {}
        <div className="mb-16">
          <h3 className="font-default text-muted-foreground mb-8 text-center text-sm tracking-[0.3em] uppercase">
            Connect with our craftsmen
          </h3>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2 max-w-2xl mx-auto">
            {socials.map((social, i) => <Link key={social.name} to={social.href} data-index={i} className="bg-card border-border hover:border-primary hover:shadow-primary/5 group flex flex-col items-center rounded-md border p-8 text-center transition-all duration-500 hover:-translate-y-1 hover:shadow-xl">
                <div className="bg-secondary text-primary mb-4 rounded-md p-4 transition-transform duration-500 group-hover:scale-110">
                  <social.icon className="size-8" />
                </div>
                <h4 className="font-default mb-2 text-lg font-bold tracking-widest uppercase">
                  {social.name}
                </h4>
                <p className="text-muted-foreground text-sm font-default">{social.desc}</p>
              </Link>)}
          </div>
        </div>

        <Separator className="bg-border/20 my-12" />

        {}
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
          <Link to="/" className="shrink-0">
            <WvcLogo className="h-12 w-auto" />
          </Link>

          <div className="flex flex-col items-center gap-4 text-center md:items-end md:text-right">
            <h3 className="font-default text-muted-foreground text-sm font-bold tracking-[0.2em] uppercase">
              Licensed & Insured Residential General Contractor
            </h3>
            <div className="flex flex-wrap justify-center gap-4 md:justify-end">
              <Button variant="outline" className="border-border hover:border-primary hover:text-primary rounded-md gap-2 font-default uppercase tracking-wider text-xs">
                <Smartphone className="size-4" />
                Denver Metro
              </Button>
              <Button variant="outline" className="border-border hover:border-primary hover:text-primary rounded-md gap-2 font-default uppercase tracking-wider text-xs">
                <Download className="size-4" />
                Lakewood Area
              </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-border/20 my-8" />

        {}
        <div className="text-muted-foreground flex flex-col items-center justify-between gap-6 text-sm md:flex-row">
          <div className="flex flex-col items-center gap-6 md:flex-row">
            <MenuProvider menu_id="68">
              <FooterMenuConsumer />
            </MenuProvider>
            <span className="text-border/30 hidden md:inline-block">|</span>
            <Link to="mailto:build@btremodeling.com" className="transition-colors hover:text-primary font-default">
              build@btremodeling.com
            </Link>
          </div>

          <div className="flex flex-wrap justify-center gap-6 font-default text-xs uppercase tracking-widest">
            <Link to="#" className="transition-colors hover:text-primary">
              Privacy
            </Link>
            <Link to="#" className="transition-colors hover:text-primary">
              Terms
            </Link>
            <Link to="#" className="transition-colors hover:text-primary">
              © BT Remodeling
            </Link>
          </div>
        </div>
      </div>
    </section>;
}